import { useState } from "react";
import { css } from '@emotion/css';
import { ButtonImage, ButtonConfig } from '../../Panel/Component';
import { Modal, ButtonGroup } from "react-bootstrap";
import { Main } from "./Editor";
interface Props {
    img: string
    setImg: (img: string) => void,
    aspect: number
}
export function CropModal({ img, setImg, aspect }: Props) {
    return <ButtonGroup>
        <ButtonImage setData={setImg} />
        <EditModal setImg={setImg} img={img} aspect={aspect} />
    </ButtonGroup>
}
export function EditModal({ img, setImg, aspect }: Props) {
    const [open, setOpen] = useState(false);
    return <>
        <Modal Modal className={css`
        padding: 0 0 0 0  !important;
        &> .modal-dialog{
            margin: 0 0 0 0  !important;
            padding: 0 0 0 0  !important;
            width:100vw;
            height:100vh;
            max-width: 100vw;
        }
        &> .modal-dialog> .modal-content{
            margin: 0 0 0 0  !important;
            width:100vw;
            height:100vh;
        }`} style={{ overflow: 'hidden' }} animation show={open} onHide={() => setOpen(false)}>
            <Modal.Body>
                <Main close={() => setOpen(false)} img={img} setImg={(s) => { setImg(s); setOpen(false) }} aspect={aspect} />
            </Modal.Body>
        </Modal>
        <ButtonConfig tip='EDITAR IMAGEN' action={() => setOpen(true)} icon='fas fa-edit' />
    </>
}